import type { HistoryPage, PublicStation, StationPage } from './types';

export class ListenerApi {
  async stations(signal?: AbortSignal): Promise<StationPage> {
    return this.json<StationPage>('/api/v1/public/stations', signal);
  }

  async history(slug: string, signal?: AbortSignal): Promise<HistoryPage> {
    return this.json<HistoryPage>(`/api/v1/public/history?station=${encodeURIComponent(slug)}&limit=12`, signal);
  }

  events(slug: string, onStation: (station: PublicStation) => void, onState: (state: 'live' | 'reconnecting') => void): EventSource {
    const source = new EventSource(`/api/v1/public/events?station=${encodeURIComponent(slug)}`);
    const receive = (event: Event): void => {
      const message = event as MessageEvent<string>;
      onStation(JSON.parse(message.data) as PublicStation);
      onState('live');
    };
    source.addEventListener('station.snapshot', receive);
    source.addEventListener('station.now_playing.changed', receive);
    source.onopen = () => onState('live');
    source.onerror = () => onState('reconnecting');

    return source;
  }

  private async json<T>(url: string, signal?: AbortSignal): Promise<T> {
    const init: RequestInit = { headers: { Accept: 'application/json' } };
    if (signal !== undefined) init.signal = signal;
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`Listener request failed with HTTP ${response.status}.`);

    return response.json() as Promise<T>;
  }
}
